import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { PostProspectResponse } from '../../Models/Models/Customer/PostProspectResponse';
import { RoleType } from '../../Constants/Enums/RoleType';
import { FullClientDetailModel } from '../../Models/Models/Customer/FullClientDetailModel';
import { ControllingPersonType } from '../../Constants/Enums/Customer/ControllingPersonType';
import { InterestedParty } from '../../Models/Models/Customer/InterestedParty';
import { ServiceValidationError } from '../../Core/DataTypes/ServiceValidation/ServiceValidationError';

declare var IS_RUNNING_IN_APP_POOL;

export class InterestedPartyClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(actorCategory: number, hierarchyIds: Array<string>, roleType: RoleType, clientPortalAccess: boolean, clientDetail: FullClientDetailModel, controllingPersonType: ControllingPersonType): Promise<PostProspectResponse, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/InterestedParty/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorCategory: actorCategory, hierarchyIds: hierarchyIds, roleType: roleType, clientPortalAccess: clientPortalAccess, clientDetail: clientDetail, controllingPersonType: controllingPersonType }

    return AjaxWrapper.post<PostProspectResponse, any>(url, data);
  }
  public put(hierarchyId: string, roleType: RoleType, clientPortalAccess: boolean, clientDetail: FullClientDetailModel, controllingPersonType: ControllingPersonType): Promise<FullClientDetailModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/InterestedParty/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, roleType: roleType, clientPortalAccess: clientPortalAccess, clientDetail: clientDetail, controllingPersonType: controllingPersonType }

    return AjaxWrapper.put<FullClientDetailModel, any>(url, data);
  }
  public get(hierarchyId: string, investorType: number, customerId: number): Promise<Array<InterestedParty>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/InterestedParty/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, investorType: investorType, customerId: customerId }

    return AjaxWrapper.get<Array<InterestedParty>, any>(url, data);
  }
  public delete(actorId: number, hierarchyId: string, roleType: RoleType): Promise<Array<ServiceValidationError>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/InterestedParty/Delete';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { actorId: actorId, hierarchyId: hierarchyId, roleType: roleType }

    return AjaxWrapper.delete<Array<ServiceValidationError>, any>(url, data);
  }
}

